<template>
    <el-dialog title="评审意见" :visible.sync="visible" width="80%" class="BorderRadius" :before-close="CloseDig" top="5vh">
        <div class="MaxHei">
            <div>
                <div class="PSTit" v-if="rowData.xingshi_name">{{rowData.xingshi_name}}</div>
                <div class="PSFuTit" v-if="rowData.opinion">建议：{{rowData.opinion}}</div>
                <el-table v-if="rowData.xingshi" :data="rowData.xingshi" border stripe style="width: 100%;" class="custom-header-table">
                    <el-table-column prop="indicator" label="评价指标" min-width="100"></el-table-column>
                    <el-table-column prop="description" label="描述" min-width="200"></el-table-column>
                    <el-table-column prop="gl_yj" label="审查建议" min-width="200"></el-table-column>
                </el-table>
            </div>
            <div>
                <div class="PSTit" v-if="rowData.Online_name">{{rowData.Online_name}}</div>
                <div class="PSFuTit" v-if="rowData.OnlineOpinion" v-for="(item,index) in rowData.OnlineOpinion">建议({{index+1}})：{{item}}</div>
                <el-table v-if="rowData.Online" :data="rowData.Online" border stripe style="width: 100%;" class="custom-header-table">
                    <el-table-column prop="indicator" label="评价指标" min-width="100"></el-table-column>
                    <el-table-column prop="description" label="描述" min-width="200"></el-table-column>
                    <el-table-column prop="opinion_data" label="评审意见" min-width="150">
                        <template slot-scope="scope">
                            <div v-for="(item,index) in scope.row.opinion_data" v-if="item">意见（{{index+1}}）{{item}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div>
                <div class="PSTit" v-if="rowData.Final_name">{{rowData.Final_name}}</div>
                <div class="PSFuTit" v-if="rowData.FinalOpinion" v-for="(item,index) in rowData.FinalOpinion">建议({{index+1}})：{{item}}</div>
                <el-table v-if="rowData.Final" :data="rowData.Final" border stripe style="width: 100%;" class="custom-header-table">
                    <el-table-column prop="indicator" label="评价指标" min-width="100"></el-table-column>
                    <el-table-column prop="description" label="描述" min-width="200"></el-table-column>
                    <el-table-column prop="opinion_data" label="评审意见" min-width="150">
                        <template slot-scope="scope">
                            <div v-for="(item,index) in scope.row.opinion_data" v-if="item">意见（{{index+1}}）{{item}}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div>
                <div class="PSTit" v-if="rowData.Dianping_name">{{rowData.Dianping_name}}</div>
                <el-table v-if="rowData.Dianping" :data="rowData.Dianping" border stripe style="width: 100%;" class="custom-header-table">
                    <el-table-column prop="dianping:" label="点评意见" min-width="100"></el-table-column>
                    <el-table-column prop="opinion_data" label="附件" min-width="150">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.dianping_url" type="success" @click="LockUrl(scope.row.dianping_url)">附件</el-tag>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "RecordDialog",
        props: {
            // 弹窗显隐状态 (父组件传值)
            visible: {
                type: Boolean,
                default: false,
            },
            // 表单详情数据 包含group和gl_file
            rowData: {
                type: Object,
                default: () => ({
                    Final: "",
                    Online: "",
                    score_rule: "",
                }),
            },
        },
        methods: {
            CloseDig() {
                this.$emit("cancel");
            },
            LockUrl(url){
                window.open(this.$Tools.ServeUrl()+url)
            },
        },
    };
</script>

<style scoped>
    .MaxHei {
        max-height: 600px;
        overflow-y: auto;
    }

    .PSTit {
        padding: 10px 0;
        font-size: 16px;
        font-weight: 700;
    }
    .PSFuTit{
        padding-bottom:5px;
        font-size: 14px;
    }
</style>